import styled from 'react-emotion'
import * as React from 'react'
import { Row, Column, styleguide } from 'styleguide'

const FakeNativeButton = styled.div`
  border-radius: 100%;
  max-width: 8px;
  width: 100%;
  height: 8px;
  background-color: ${styleguide.colors.foreground};
  margin-right: 8px;
`

const FakeBrowser = styled(Column)`
  background-color: #ffffff;
  border: 1px solid ${styleguide.colors.foreground};
  width: 100%;
  max-width: 1000px;
  border-radius: ${styleguide.radii.browser};
  overflow: hidden;
  position: relative;
  ${styleguide.shadows.button};
`

export default ({ children, className }) => (
  <FakeBrowser justify="start" align="stretch" className={className} grow>
    <Row
      justify="start"
      css={`
        height: 20px;
        border-bottom: 1px solid ${styleguide.colors.foreground};
        padding: 4px 8px;
      `}>
      <FakeNativeButton />
      <FakeNativeButton />
      <FakeNativeButton />
    </Row>
    <div
      css={`
        width: 100%;
        position: relative;
        padding-top: 62.6%;
      `}>
      {children}
    </div>
  </FakeBrowser>
)



// WEBPACK FOOTER //
// ./src/components/FakeBrowser.jsx